import React from 'react';
import { AdminRouteName } from '../../../CONSTANTS';

import TransactionTableRecords from '../TransactionTableRecord';

const FailedTransaction = () => (
  <div className="transaction-root-cover"><TransactionTableRecords hasNameAndImage defaultUrl={AdminRouteName.failedTransactionRoute} tabStatus="failed" toggleStorageId="failed-transaction-table-col" recordPermission="can-view-failed-transaction" /></div>
);
export default FailedTransaction;
